<template>
  <v-app id="inspire" class="gradient-color">
    <v-main class="pl-8 gradient-color">
      <v-container fluid>
        <v-layout justify-center>
          <Logo class="mt-16 mr-2" />
        </v-layout>

        <v-dialog v-model="dialog" persistent max-width="600px" min-width="360px">
          <v-card class="px-4 pt-4">
            <v-card-text>
              <v-form ref="form" v-model="isFormValid" lazy-validation @submit.prevent="submit">
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="email"
                      :rules="formRules.emailRules"
                      :error-count="auth_error"
                      :error-messages="['Email e/ou senha incorreto(s)']"
                      label="Email"
                      required
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-text-field
                      v-model="password"
                      :rules="formRules.passwordRules"
                      label="Senha"
                      required
                      hide-details="auto"
                      :append-icon="show_password ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show_password ? 'text' : 'password'"
                      @click:append="show_password = !show_password"
                    ></v-text-field>
                  </v-col>
                  
                  <v-spacer></v-spacer>
                  <v-col class="d-flex" cols="6" md="6" sm="6">
                    <!-- <v-btn 
                      large block 
                      outlined
                      color="#0dc4b8"
                      type="submit"
                      :disabled="isLoading"
                    > 
                      Registrar 
                    </v-btn> -->
                  </v-col>
                  <v-col class="d-flex" cols="6" md="6" sm="6" align-end>
                    <v-btn 
                      large block 
                      outlined
                      color="#0dc4b8" 
                      type="submit"
                      @click="submit"
                      :disabled="isLoading"
                      :loading="isLoading"
                    > 
                      Entrar
                    </v-btn>
                  </v-col>

                  <v-col class="d-flex" cols="6" md="6" sm="6" align-end>
                    <v-btn x-small text color="#0dc4b8" :disabled="isLoading" @click="forgottenPasswordDialog = !forgottenPasswordDialog">
                      Esqueceu sua senha?
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="forgottenPasswordDialog"
          max-width="500px"
        >
          <v-card>
            <v-form ref="forgottenPasswordForm" v-model="isFormValid" lazy-validation @submit.prevent="submit">
              <v-card-title>
                Recuperar senha
              </v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="forgottenPasswordEmail"
                  :rules="formRules.emailRules"
                  label="Email"
                  hide-details="auto"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#0dc4b8" 
                  text
                  @click="forgottenPasswordDialog = false"
                >Cancelar</v-btn>
                <v-btn
                  color="#0dc4b8" 
                  text
                  type="submit"
                  @click="submitForgottenPassword"
                  :disabled="isLoading"
                  :loading="isLoading"
                >Enviar</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-container>
      <Snackbar />
    </v-main>
  </v-app>
</template>

<script>
import { mapMutations } from 'vuex';
import Snackbar from '@/components/Snackbar'
import AuthService from '../services/auth.service.js';
import Logo from '@/components/Logo.vue';

export default {
  name: 'Login',
  components: {
    Snackbar,
    Logo
  },
  data: () => ({
    auth_error: 0,
    dialog: true,
    email: null,
    forgottenPasswordDialog: false,
    forgottenPasswordEmail: null,
    formRules: {
      emailRules: [
        v => !!v || 'Email é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail inválido',
      ],
      passwordRules: [
        v => !!v || 'Senha é obrigatória',
      ],
    },
    isFormValid: true,
    isLoading: false,
    password: null,
    show_password: null,
  }),
  methods: {
    ...mapMutations(["showSnackbar"]),

    submit () {
      if(this.$refs.form.validate()) {
        this.isLoading = true;
        this.auth_error = 0;
         
        let data = { 
          email: this.email,
          password: this.password,
          version: 'v11 08/04/2022'
        };

        this.$store.dispatch('login', data)
       .then(() => this.$router.push('/user-roles'))
       .catch(err => {
            console.log(err);
            this.auth_error = 1;
            this.isLoading = false;
          })
      }
    },

    submitForgottenPassword () {
      if(this.$refs.forgottenPasswordForm.validate()) {
        this.isLoading = true;
         
        AuthService.sendResetLink({ email: this.forgottenPasswordEmail })
          .then(() => this.showSnackbar({ text: "Link para recuperação de senha enviado com sucesso!", color:"success" }) )
          .catch(err => {
            if (err.response.status == 404)
              this.showSnackbar({ text: "Ops! Email informado não foi localizado", color:"error" })
            else
              this.showSnackbar({ text: "Ops! Ocorreu um erro inesperado", color:"error" })
          })
          .finally(() => setTimeout(() => { this.isLoading = false; this.forgottenPasswordDialog = false; }, 300));
      }
    },
  }
};
</script>
